module.exports = "<p>\n  bill-pdf works!\n</p>\n"